<template>
  <!-- 卡片区域 -->
  <view class="card-view">
    <!-- 常用 -->
    <view>
      <view class="card-hotel" v-for="(item, index) in frequentlyUsed" :key="item.id" @click="goToBook(index)">
        <view class="a-flex a-jc-sb a-ai-c">
          <view class="a-flex a-col a-w-150 a-ai-fs">
            <view class="a-fs-32 a-lh-32 a-fw-500 a-c-#14">{{ item.departureDate }}</view>
            <view class="a-fs-24 a-lh-24 a-h-24 a-mt-10 a-c-#14 a-ellipsis-1">{{ item.departureInfo }}</view>
          </view>
          <view class="a-flex a-col a-jc-sb a-ai-c a-m-0-25 a-h-100%">
            <view class="a-fs-20 a-lh-20 a-c-#59">{{ item.requiredTime }}</view>
            <image class="a-w-120 a-h-10 a-m-10-0" src="https://image.ceekee.com/app/flight/icon_tripto.png"></image>
            <view class="a-fs-20 a-lh-20 a-c-#59">{{ item.mainKey }}</view>
          </view>
          <view class="a-flex a-col a-w-150 a-ai-fe">
            <view class="a-fs-32 a-lh-32 a-fw-500 a-c-#14">{{ item.arrivalDate }}</view>
            <view class="a-fs-24 a-lh-24 a-h-24 a-mt-10 a-c-#14 a-ellipsis-1">{{ item.arrivalInfo }}</view>
          </view>
        </view>
        <view
          class="tripwise_outline icon-delete_outline a-fs-32 a-c-#057bff a-mr-20"
          v-if="isEdit"
          @click="$emit('delete', item)"
        ></view>
        <BookBtn
          v-else
          :ref="'bookBtnRef' + index"
          :width="80"
          :height="80"
          :borderRadius="8"
          :fontSize="36"
          :productType="6"
          :productInfo="item"
          :startDate="startDate"
        />
      </view>
      <view
        v-if="list.frequentlyUsed.length > 5 && !showMoreControl.offen && !isEdit && pageFrom !== 'popup'"
        class="a-h-36 a-w-100% a-flex a-jc-c a-ai-c a-fs-24 a-c-#59 a-mt-20"
        @click="changeMoreControl('offen')"
      >
        查看更多
        <view class="tripwise_outline icon-arrowdn_outline a-fs-24 a-ml-8"></view>
      </view>
      <view
        v-if="list.frequentlyUsed.length > 5 && !showMoreControl.offen && !isEdit && pageFrom === 'popup'"
        class="a-h-68 a-lh-68 a-w-100% a-br-12 a-bg-#F8F9FA a-flex a-jc-c a-ai-c a-fs-28 a-c-#59 a-mt-20"
        @click="$emit('jumpToCommonlyUsed')"
      >
        查看更多
        <view class="tripwise_outline icon-arrowright_outline a-fs-24 a-ml-8"></view>
      </view>
      <view
        v-if="
          !isEdit &&
          list.frequentlyUsed.length > 0 &&
          list.frequentlyUsed.length < 20 &&
          (list.frequentlyUsed.length <= 5 || (list.frequentlyUsed.length > 5 && showMoreControl.offen))
        "
        class="a-w-100% a-h-68 a-lh-68 a-br-12 a-flex a-jc-c a-ai-c a-mt-20 a-bg-#F8F9FA a-fs-28 a-c-#59"
        @click="$emit('goIndexLine')"
      >
        添加更多常用车次
        <view class="tripwise_outline icon-arrowright_outline a-fs-24 a-c-#59 a-ml-8"></view>
      </view>
    </view>
    <!-- 没有数据 -->
    <view class="empty-wrapper" v-if="list.frequentlyUsed.length === 0 && !isEdit">
      <img class="a-w-250 a-h-250" src="https://image.ceekee.com/error/icon_nodata.png" />
      <view class="a-fs-24 a-mt-10 a-c-#141414">暂无内容，您可以前往列表添加</view>
      <view
        class="a-w-150 a-64 a-lh-64 a-br-12 a-bg-#F85A5B a-ta-c a-fs-24 a-fw-600 a-c-#f a-mt-40"
        @click="$emit('goIndexLine')"
        >去添加</view
      >
    </view>
    <!-- 最近预订 -->
    <view v-if="!isEdit && list.frequentlyBook.length > 0 && pageFrom !== 'popup'">
      <view class="a-flex a-jc-sb a-ai-c a-mt-30 a-mb-20">
        <view class="a-fs-28 a-fw-500 a-lh-28 a-c-#14">最近预订</view>
        <view
          class="a-flex a-ai-c a-fs-24 a-c-#59 a-h-24"
          v-if="list.frequentlyBook.length > 1 && !showMoreControl.book"
          @click="changeMoreControl('book')"
        >
          更多
          <view class="tripwise_outline icon-arrowdn_outline a-fs-24 a-ml-8"></view>
        </view>
      </view>
      <view class="card-hotel" v-for="(item, index) in frequentlyBook" :key="item.id">
        <view class="a-flex a-jc-sb a-ai-c">
          <view class="a-flex a-col a-w-150 a-ai-fs">
            <view class="a-fs-32 a-lh-32 a-fw-500 a-c-#14">{{ item.departureDate }}</view>
            <view class="a-fs-24 a-lh-24 a-h-24 a-mt-10 a-c-#14 a-ellipsis-1">{{ item.departureInfo }}</view>
          </view>
          <view class="a-flex a-col a-jc-sb a-ai-c a-m-0-25 a-h-100%">
            <view class="a-fs-20 a-lh-20 a-c-#59">{{ item.requiredTime }}</view>
            <image class="a-w-120 a-h-10 a-m-10-0" src="https://image.ceekee.com/app/flight/icon_tripto.png"></image>
            <view class="a-fs-20 a-lh-20 a-c-#59">{{ item.mainKey }}</view>
          </view>
          <view class="a-flex a-col a-w-150 a-ai-fe">
            <view class="a-fs-32 a-lh-32 a-fw-500 a-c-#14">{{ item.arrivalDate }}</view>
            <view class="a-fs-24 a-lh-24 a-h-24 a-mt-10 a-c-#14 a-ellipsis-1">{{ item.arrivalInfo }}</view>
          </view>
        </view>
        <view
          class="a-w-94 a-h-38 a-br-20 a-bg-#057bff a-fs-22 a-lh-22 a-c-#fff a-flex a-jc-c a-ai-c"
          @click="$emit('add', item)"
        >
          <view class="tripwise_outline icon-tip_outline1 a-fs-22 a-c-#fff a-mr-4"></view>
          常用
        </view>
      </view>
    </view>
    <!-- 最近常看 -->
    <view v-if="!isEdit && list.frequentlySaw.length > 0 && pageFrom !== 'popup'">
      <view class="a-flex a-jc-sb a-ai-c a-mt-30 a-mb-20">
        <view class="a-fs-28 a-fw-500 a-lh-28 a-c-#14">最近常看</view>
        <view
          class="a-flex a-ai-c a-fs-24 a-c-#59 a-h-24"
          v-if="list.frequentlySaw.length > 1 && !showMoreControl.see"
          @click="changeMoreControl('see')"
        >
          更多
          <view class="tripwise_outline icon-arrowdn_outline a-fs-24 a-ml-8"></view>
        </view>
      </view>
      <view class="card-hotel" v-for="(item, index) in frequentlySaw" :key="item.id">
        <view class="a-flex a-jc-sb a-ai-c">
          <view class="a-flex a-col a-w-150 a-ai-fs">
            <view class="a-fs-32 a-lh-32 a-fw-500 a-c-#14">{{ item.departureDate }}</view>
            <view class="a-fs-24 a-lh-24 a-h-24 a-mt-10 a-c-#14 a-ellipsis-1">{{ item.departureInfo }}</view>
          </view>
          <view class="a-flex a-col a-jc-sb a-ai-c a-m-0-25 a-h-100%">
            <view class="a-fs-20 a-lh-20 a-c-#59">{{ item.requiredTime }}</view>
            <image class="a-w-120 a-h-10 a-m-10-0" src="https://image.ceekee.com/app/flight/icon_tripto.png"></image>
            <view class="a-fs-20 a-lh-20 a-c-#59">{{ item.mainKey }}</view>
          </view>
          <view class="a-flex a-col a-w-150 a-ai-fe">
            <view class="a-fs-32 a-lh-32 a-fw-500 a-c-#14">{{ item.arrivalDate }}</view>
            <view class="a-fs-24 a-lh-24 a-h-24 a-mt-10 a-c-#14 a-ellipsis-1">{{ item.arrivalInfo }}</view>
          </view>
        </view>
        <view
          class="a-w-94 a-h-38 a-br-20 a-bg-#057bff a-fs-22 a-lh-22 a-c-#fff a-flex a-jc-c a-ai-c"
          @click="$emit('add', item)"
        >
          <view class="tripwise_outline icon-tip_outline1 a-fs-22 a-c-#fff a-mr-4"></view>
          常用
        </view>
      </view>
    </view>
  </view>
</template>

<script>
import BookBtn from '@/componentsV3/biz/CardBookTagList/BookBtn.vue';
import dayjs from 'dayjs';

export default {
  components: { BookBtn },
  props: {
    list: {
      type: Object,
      default: () => {
        return {
          frequentlyUsed: [],
          frequentlyBook: [],
          frequentlySaw: [],
        };
      },
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    showMoreControl: {
      type: Object,
      default: () => {
        return {
          offen: false,
          book: false,
          see: false,
        };
      },
    },
    pageFrom: {
      type: String,
      default: 'page',
    },
  },
  data() {
    return {
      startDate: dayjs().add(1, 'day').format('YYYY-MM-DD'),
    };
  },
  computed: {
    frequentlyUsed() {
      return this.showMoreControl.offen || this.isEdit
        ? this.list.frequentlyUsed
        : this.list.frequentlyUsed.slice(0, 5);
    },
    frequentlyBook() {
      return this.showMoreControl.book ? this.list.frequentlyBook : this.list.frequentlyBook.slice(0, 1);
    },
    frequentlySaw() {
      return this.showMoreControl.see ? this.list.frequentlySaw : this.list.frequentlySaw.slice(0, 1);
    },
  },
  methods: {
    goToBook(index) {
      if (this.isEdit) {
        return;
      }
      this.$refs[`bookBtnRef${index}`][0].handleBtnBook();
    },
    changeMoreControl(type) {
      this.$emit('changeMoreControl', type);
    },
  },
};
</script>

<style lang="scss" scoped scoped>
.card-hotel {
  width: 100%;
  height: 120rpx;
  border-radius: 12rpx;
  padding: 20rpx 20rpx 20rpx 30rpx;
  box-shadow: 0px 30rpx 30rpx 0px rgba(0, 0, 0, 0.02);
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20rpx;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
